exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".case-title{color:#8f9bb3;font-size:14px}.header-row{margin-bottom:20px}.case-count-number{color:#222b45;font-size:20px;font-weight:600}.case-goal .case-goal-count{display:inline-flex;margin-bottom:-0.8em}.case-goal .case-goal-count .case-title{margin-top:5px;margin-left:5px}.case-goal .case-goal-count .case-title:hover{margin-top:5px;margin-left:5px}.case-goal .case-title-goal{font-size:12px;text-decoration:none;cursor:pointer;color:#8f9bb3;font-weight:600;letter-spacing:1px}.case-goal .case-title:hover{text-decoration:none;cursor:pointer}.case-goal .progressbar{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/ActivityCenter/SubComponents/CaseHeader.scss
// module id = 1505
// module chunks = 101